import React, { useState } from 'react';
import { useRecoilValue } from 'recoil';
import {
    Box,
    Divider,
} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import { authTokenState } from 'features/auth/state/authAtoms';
import { selectedStudyState } from 'features/optimization/state/studyAtoms';
import { CustomTypography } from 'shared/ui/CustomTypography';
import { CustomButton } from 'shared/ui/CustomButton';
import { fetchStudyCsvData } from 'features/optimization/api/fetchStudyCsvData';

const subtitleSx = {
    display: 'flex',
    alignItems: 'center',
};

export const OptimizationDownload: React.FC = () => {
    const authToken = useRecoilValue(authTokenState);
    const selectedStudy = useRecoilValue(selectedStudyState);
    const [apiLoading, setApiLoading] = useState<boolean>(false);

    const handleClick = async () => {
        setApiLoading(true);
        if (authToken !== '') {
            if (selectedStudy?.name) {
                await fetchStudyCsvData(authToken, selectedStudy.name);
            }
        }
        setApiLoading(false);
    };

    return (
        <Box component="div" sx={{ boxSizing: 'border-box', flexGrow: 1, paddingTop: 1 }}>
            <Box component="div" sx={subtitleSx}>
                <CustomTypography >Optimization Download</CustomTypography>
            </Box>

            <Divider sx={{ my: 0.5, bgcolor: '#e1e1e1' }} />

            <Box component="div" sx={{ width: '40%' }}>
                <CustomButton
                    size='small'
                    disabled={apiLoading}
                    onClick={handleClick}
                    loading={apiLoading}
                    loadingPosition='start'
                    startIcon={<DownloadIcon />}
                    variant='contained'
                    sx={{ fontSize: '10px', width: '100%' }}
                >
                    Download
                </CustomButton>
            </Box >
        </Box>
    );
};
